import * as React from "react";

import {
  Modal,
  Form,
  FormGroup,
  Label,
  ModalFooter,
  Button,
  ModalBody,
  ModalHeader,
  Input
} from "reactstrap";

import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { settings } from "settings";

import i18n from "../i18n";

export interface UserRoleEditProps {
  item: any;
  isOpen: boolean;
  isNew: boolean;
  onSave: (model: any) => void;
  onCancel: () => void;
}
export interface UserRoleEditState {
  userEmailAddress: string;
  userRoles: string [];
  item: any;
}

export default class UserRoleEdit extends React.Component<
UserRoleEditProps,
  UserRoleEditState
> {
  constructor(props: UserRoleEditProps) {
    super(props);
    this.state = {
      userEmailAddress: "",
      userRoles: settings.roles,
      item: props.item
    };
  }

  componentDidMount() {
   // this.loadModels();
  }
  componentWillReceiveProps(nextProps: UserRoleEditProps) {
    this.setState({
      item: nextProps.item
    });
  }

  render() {
    const { isOpen, onSave, onCancel, isNew } = this.props;
    const model = this.model;
    return (
      <Modal isOpen={isOpen} className="scenario-edit">
        <ModalHeader>
          {isNew ? i18n.UserRoles.Form.NewTitle : i18n.UserRoles.Form.EditTitle}
        </ModalHeader>
        <ModalBody>
          {model && (
            <Form>
            <FormGroup>
                <Label>{i18n.UserRoles.EditEmail}</Label>
                <Input
                  size={50}
                  value={model.upn}
                  onChange={e => this.updateField("upn", e)}
                  readOnly={!this.props.isNew}
                />
              </FormGroup>
              <FormGroup>
                <Label>{i18n.UserRoles.EditRole}</Label>
                <Typeahead
                  multiple={false}
                  labelKey="role"
                  bsSize="sm"
                  defaultInputValue={(model.role || ""
                  )}

                  // selected={(model.userRoleType)}
                  allowNew={false}
                  options={this.state.userRoles || []}
                  selectHintOnEnter={true}
                  onChange={e => this.updateField("role", null, e)}
                />
              </FormGroup>
              </Form>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => onSave(model)}
            disabled={!this.isValid}
          >
            {i18n.Global.Edit.Confirm}
          </Button>
          <Button color="default" onClick={() => onCancel()}>
            {i18n.Global.Edit.Cancel}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  private get model() {
    return this.state.item;
  }

  private get isValid(): boolean {
    return this.model !== null;
  }

  private updateField(
    field: string,
    e: React.ChangeEvent<HTMLInputElement> | null,
    value?: any
  ) {
    const temp = {};
    switch (field) {
      case "intents":
      case "type":
      case "entities":
      case "market":
        temp[field] = value.map((x: any) => (x.name ? x.name : x)).join(",");
        break;
      default:
        temp[field] = e ? e.target.value : value;
        break;
    }
    this.setState({
      item: {
        ...this.state.item,
        ...temp
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/userRoles/userRoles-edit.tsx